<template>
  <div>
    <shop-header :store-id="storeid" />
    <form @submit.prevent="placeOrder">
      <div class="container main-container">
        <div class="row">
          <div class="col-sm-7 col-xl-8">
            <div class="bg-white py-4 mb-2">
              <div class="p-4 d-flex justify-content-center">
                <div class="w-85">
                  <h4>{{ $t('message.gettingYourGiftcard') }}</h4>

                  <my-detail
                    ref="myDetails"
                    :edit-model="detailModel"
                    @save-user="saveUser"
                    :for-gift="true"
                  />
                  <div
                    class="mt-2"
                    v-if="
                        (viewConfig.EnableAlipayPayment ||
                        viewConfig.EnableWechatPayment) &&
                        false
                    "
                  >
                    <div class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-4">
                        <input
                          id="payByCardInput"
                          :checked="paymentMethod == 1"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="payByCardMode"
                        />
                        <label
                          class="custom-control-label"
                          for="payByCardInput"
                        >{{ $t("message.payByCard") }}</label>
                      </div>
                    </div>
                    <div v-if="viewConfig.EnableAlipayPayment" class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-4">
                        <input
                          id="payByAlipayInput"
                          :checked="paymentMethod == 4"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="payByAlipayMode"
                        />
                        <label
                          class="custom-control-label"
                          for="payByAlipayInput"
                        >{{ $t("message.payByAlipay") }}</label>
                      </div>
                    </div>
                    <div v-if="viewConfig.EnableWechatPayment" class="form-row">
                      <div class="custom-control custom-radio col-md-8 ml-4">
                        <input
                          id="payByWechatInput"
                          :checked="paymentMethod == 5"
                          type="radio"
                          name="customCheckbox"
                          class="custom-control-input"
                          @change="payByWechatMode"
                        />
                        <label
                          class="custom-control-label"
                          for="payByWechatInput"
                        >{{ $t("message.payByWechat") }}</label>
                      </div>
                    </div>
                  </div>
                  <payment
                    v-show="showPayment && (!viewConfig.EnableAlipayPayment &&
                          !viewConfig.EnableWechatPayment) ||
                          paymentMethod == 1"
                    ref="payment"
                    :edit-model="paymentModel"
                    @save-credit="saveCredit"
                  />
                  <div v-show="error" class="w-100 mt-4">
                    <div class="alert alert-danger" role="alert">
                      <strong v-html="error"></strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-5 col-xl-4">
            <ShoppingCart
              ref="shoppingCart"
              :proccessing="proccessing"
              :order-type="orderType"
              order-mode
            />
          </div>
        </div>
      </div>
    </form>
    <shopfooter />
  </div>
</template>
<script>
import MyDetail from "../../../components/shop/Checkout/partials/MyDetail";
import ShoppingCart from "./../giftshoppingcart/GiftShoppingCart";
import Payment from "../../../components/shop/Checkout/partials/Payment";
import ShopHeader from "../../../components/shop/partials/shopheader";
import shopfooter from "./../../shared/shopfooter";
import shared from "../../../sharedscripts/shop/Checkout/giftCheckout.js";
export default {
  components: {
    MyDetail,
    Payment,
    ShoppingCart,
    ShopHeader,
    shopfooter
  },
  props: {
    storeid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      error: "",
      userIsExist: false,
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone: ""
      },
      isDelivery: true,
      deliveryAddressModel: {
        StreetAddress: "",
        PostalCode: "",
        CityTown: "",
        DeliveryInstructions: "",
        State: "",
        Latitude: "",
        Longitude: ""
      },
      paymentModel: {
        CardHolder: "",
        CardNumber: "",
        ExpireDate: "",
        CVV: "",
        SelectedCard: null
      },
      registerNew: false,
      saveCard: false,
      payByCard: false,
      proccessing: false,
      paymentMethod: 1,
      guestUserId: null
    };
  },

  computed: {
    ...shared.computed
  },
  watch: {
    holder() {
      this.paymentModel.CardHolder = this.holder;
    }
  },
  mounted() {
    if (localStorage.getItem("giftCheckoutData")) {
      var initialState = function() {
        return JSON.parse(localStorage.getItem("giftCheckoutData"));
      };
      Object.assign(this.$data, initialState());
    }

    if (this.$route.query.result) {
      if (
        this.$route.query.result === "SUCCESS" &&
        this.$route.query.merchant_trade_no
      ) {
        localStorage.removeItem("giftCheckoutData");
        this.processPayment(
          this.$route.query.merchant_trade_no,
          this.guestUserId
        );
      } else {
        this.error = this.$route.query.trade_status;
      }
    }
  },
  methods: {
    ...shared.methods,
    setUserIsExist(value) {
      this.userIsExist = value;
    }
  }
};
</script>
